import React from 'react';
import { completionChoices, isSquare } from '../utils/paymentMethods';

// Storm Mode's completion payment buttons: a Paid and a Not Paid button for
// every method the company has on (built-in or custom, list order), a plain
// Not Paid with no method, and Square on its own in the Send Invoice section.
//
// onSelect(methodId, status): status is 'paid' or 'not_paid'; the plain Not
// Paid sends (null, 'not_paid') and Square sends ('square', 'unpaid').
// The styles live in StormMode.js (.payment-option-btn and its variants).

const BUILT_IN_ICONS = { venmo: 'V', cashapp: '$', cash: '$', zelle: 'Z', check: '✓' };

const iconFor = (choice) => BUILT_IN_ICONS[choice.id]
  || (choice.name || choice.id).trim().charAt(0).toUpperCase() || '•';

const classFor = (choice, status) => {
  const kind = choice.isBuiltIn ? choice.id : 'custom';
  return `payment-option-btn ${kind}-${status === 'paid' ? 'paid' : 'not-paid'}`;
};

export default function CompletionPaymentChoices({ methods, awaitingDepth = false, onSelect }) {
  const choices = completionChoices(methods);
  const squareOn = (Array.isArray(methods) ? methods : []).some((m) => isSquare(m.id) && m.enabled && !m.deleted);

  return (
    <>
      <div className="payment-options payment-options-grid">
        {choices.map((choice) => (
          <React.Fragment key={choice.id}>
            <button className={classFor(choice, 'paid')} onClick={() => onSelect(choice.id, 'paid')}>
              <span className="payment-icon">{iconFor(choice)}</span>
              <span>{choice.name} - Paid</span>
            </button>
            <button className={classFor(choice, 'not_paid')} onClick={() => onSelect(choice.id, 'not_paid')}>
              <span className="payment-icon">{iconFor(choice)}</span>
              <span>{choice.name} - Not Paid</span>
            </button>
          </React.Fragment>
        ))}
        <button className="payment-option-btn not-paid" onClick={() => onSelect(null, 'not_paid')}>
          <span className="payment-icon">✕</span>
          <span>Not Paid</span>
        </button>
      </div>

      {squareOn && (
        <>
          <div className="payment-section-divider">
            <span>Send Invoice</span>
          </div>
          <div className="payment-options invoice-payment-options" data-testid="invoice-payment-options">
            <button
              className="payment-option-btn square"
              onClick={() => onSelect('square', 'unpaid')}
              title={awaitingDepth ? 'Recorded as Square, not paid; invoiced once the depth is entered' : undefined}
            >
              <span className="payment-icon">□</span>
              <span>{awaitingDepth ? 'Square, invoice after depth' : 'Square'}</span>
            </button>
            {awaitingDepth && (
              <p className="door-amount-hint square-depth-hint">No amount now. The invoice goes out after the depth is entered (Bill All, or automatically when auto-invoice is on).</p>
            )}
          </div>
        </>
      )}
    </>
  );
}
